export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Создать пост...',
  blogsFeedSearchInputPlaceholder: 'Поиск',
  blogsFeedPostOwnerCurtainEditTitle: 'Редактировать пост',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Удалить пост',
  blogsFeedEditedPostSavedAlertText: 'Пост сохранен!',
  blogsFeedEditedPostDeletedAlertText: 'Пост удален!',
  blogsFeedShareCurtainOptionTitle: 'Скопировать ссылку',
  blogsFeedPostLinkCopiedAlertText: 'Ссылка скопирована!',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Скопировать ссылку',
  blogsFeedOthersPosLinkCopiedAlertText: 'Ссылка скопирована!',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Пожаловаться',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Удалить пост',
  blogsFeedPostDeletePopupTitle: 'Удалить',
  blogsFeedPostDeletePopupText: 'Удалить этот пост?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Отменить',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Подтвердить',
  blogsFeedPostDeeletedAlertText: 'Пост удален!',
  blogsPostDetailsHeaderTitle: 'Пост',
  postFeedPostLikesText: 'Лайки',
  postFeedPostCommentsText: 'Комментарии',
  postFeedPostNoLikesText: 'Пока нет лайков.',
  postFeedPostLeaveFirstLikeText: 'Оставь первый лайк',
  blogsFeedPostDetailsNoCommentsText: 'Пока нет комментариев',
  blogsFeedPostDetailsFirstCommentText: 'Оставь первый комментарий',
  blogsFeedPostDetailsShareOptionTitle: 'Скопировать ссылку',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Ссылка скопирована!',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Скопировать ссылку',
  blogsFeedPostDetailsCopiedAlertText: 'Ссылка скопирована!',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Пожаловаться',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Пожаловаться',
  blogsPostDetailsReportedCurtainText: 'Жалоба отправлена',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Редактировать комментарий',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Удалить комментарий',
  blogsPostDetailsEditedCommentSavedAlertText: 'Комментарий сохранен!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Удалить комментарий',
  postDetailsOtherUsersCommentDeletadAlertText: 'Комментарий удален!',
  postDetailsDeleteCommentPopupTitle: 'Удалить',
  postDetailsDeleteCommentPopupText: 'Удалить этот комментарий?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Отменить',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Подтвердить',
  postDetailsCommDeletedAlertText: 'Комментарий удален!',
  postDetailsCommentUserCurtainOptionTitle: 'Пожаловаться на комментарий',
  blogsCreatePostCurtainTitle: 'Новый пост',
  blogsCreatePostCurtainBodyPlaceholder: 'Начните писать здесь...',
  blogsCreatePostPublishButtonTitle: 'Опубликовать',
  blogsCreatePostUploadSlallerImageAlertText: 'Вы не можете загрузить более {size} MB за раз',
  blogsPostSavedAlertText: 'Пост сохранен!',
  blogsCreatePostAddLocationCurtainTitle: 'Локация',
  blogsCreatePostAddLocationCurtainInputPlaceholder: 'Название локации',
  blogsCreatePostEditLocationCurtainText: 'Редактировать локацию',
  blogsDeleteLocation: 'Удалить локацию',
  blogsDiscardPostPopupTitle: 'Черновик',
  blogsDiscardPostPopupText: 'Удалить черновик?',
  blogsDiscardPostPopupCancelButtonTitle: 'Отменить',
  blogsDiscardPostPopupCofirmButtonTitle: 'Подтвердить',
  blogsNewPostCreatePollTitle: 'Создать опрос',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Название',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Вариант',
  blogsNewPostCreatePollAddButtonTitle: 'Добавить вариант',
  blogsNewPostCreatePollCreateButtonTitle: 'Создать',
  blogsCreatePostPollTitleBlankAlertText: 'Заполните поле!',
  blogsCreatePostPollOptionBlankAlertText: 'Заполните поле!',
  blogsCreatePostPollLongTitleAlertText: 'Название слишком длинное, выберите не более {length} символов',
  blogsCreatePostPollLongOptionAlertText: 'Вариант слишком длинный, выберите не более {length} символов',
  blogsCreatePostPollEditOptionTitle: 'Редактировать опрос',
  blogsCreatePostPollRemoveOptionTitle: 'Удалить опрос',
  blogsPostPollInfoVotesText: 'голосов',
  blogsPostPollInfoEditVoteText: 'Переголосовать',
  blogsPostPollFinishPollText: 'Завершить',
  blogsPostPollFinishedPollText: 'Завершено',
  blogsPostPollInProgresslText: 'В процессе',
  blogsFinishPollCurtainTitle: 'Завершить',
  blogsFinishPollCurtainText: 'Пользователи больше не смогут голосовать в этом опросе, когда он будет завершен.',
  blogsFinishPollCurtainCancelButtonTitle: 'Отменить',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Подтвердить',
  blogsPollInfoPollVotesCurtainTitle: 'Голоса',
  blogsEditPostCurtainTitle: 'Редактировать пост',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Начните писать здесь...',
  blogsEditPostCurtainSaveButtonTitle: 'Сохранить',
  blogsEditPostSavedAlertText: 'Пост сохранен!',
  blogsError: 'Что-то пошло не так!',
  blogsAt: 'в',
  blogsSeeMore: 'Развернуть...',
  blogsMaxAttachments: 'Вы превысили максимальное количество фотографий. Максимум {max} фото',
  blogsReply: 'Ответить',
  blogsAddCover: 'Добавить обложку'
}
